import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../Components/Table";
import {
    ListagemDeCustosController,
    RemocaoDeCustosController,
} from "../../../Controllers/AssistenciaTecnica/CustoOficialRelatoriosBI/CustoOficialRelatoriosBIController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import {
    ICustosPayload,
    IListagemDeCustos,
} from "../../../Interfaces/AssistenciaTecnica/CustoOficialRelatoriosBI/CustoOficialRelatoriosBI";
import { formatMoneyReais } from "../../../Tools/FormatTools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import ModalComponent from "../../../Components/Modais";
import CreateUpdateCustoOficial from "./CreateUpdateCustoOficial";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import Swal from "sweetalert2";
import StickyToolbar from "../../../Components/StickyToolbar";
import FiltroCustoOficial from "./FiltroCustoOficial";
import usePaginationFilter from "../../../hooks/usePaginationFilter";

const filtroInicial: ICustosPayload = {
    PAGINA: 1,
    QUANTIDADE: 10,
    NR_MES: 0,
    NR_ANO: 0,
    DS_FUNCIONARIO: "",
    VL_FINAL: "0",
    DS_PRACA: "",
};

export default function CustoOficialRelotoriosBI() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const FILTRO_CUSTOS_OFICIAL = sessionStorage.getItem(
        "FILTRO_CUSTOS_OFICIAL"
    );

    const { PageFilter, setPage, filter, setFilter } =
        usePaginationFilter<ICustosPayload>({
            page: 1,
            filter: FILTRO_CUSTOS_OFICIAL
                ? JSON.parse(FILTRO_CUSTOS_OFICIAL)
                : filtroInicial,
        });

    const [ano, setAno] = useState<string>(String(filter?.NR_ANO || ""));
    const [mes, setMes] = useState<string>(String(filter?.NR_MES || ""));

    const [funcionario, setFuncionario] = useState<string>();
    const [dsPraca, setDsPraca] = useState<string>();

    const {
        value: lstCusto,
        loading: lstCustoLoading,
        execute: ListagemDeCustos,
    } = useAsyncEffect(async () => {
        return ListagemDeCustosController({
            NR_ANO: filter?.NR_ANO ? Number(filter?.NR_ANO) : 0,
            NR_MES: filter?.NR_MES ? Number(filter?.NR_MES) : 0,
            DS_PRACA: filter?.DS_PRACA ? filter?.DS_PRACA : "",
            DS_FUNCIONARIO: filter?.DS_FUNCIONARIO
                ? filter?.DS_FUNCIONARIO
                : "",
            VL_FINAL: filter?.VL_FINAL ? filter?.VL_FINAL : "0",
            PAGINA: PageFilter.page,
            QUANTIDADE: 10,
        });
    }, [PageFilter, filter]);

    const totalPages = lstCusto?.PAGINA || 0;

    const { execute: RemocaoDeCustos, loading: RemocaoDeCustosLoading } =
        useAsyncCallback(RemocaoDeCustosController);

    const columns: Array<ColumnDescription<IListagemDeCustos>> = [
        {
            dataField: "DS_OFICIAL_FUNCIONARIO",
            text: "Funcionário oficial",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "DS_PRACA",
            text: "Praça",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "VL_FINAL",
            text: "Valor Final",
            classes: "p-3 ws-nowrap",
            formatter: (c) => formatMoneyReais(c),
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "MES",
            text: "Mês",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "ANO",
            text: "Ano",
            classes: "p-3 ws-nowrap",
            headerAlign: "center",
            align: "center",
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            align: "center",
            formatter: (c, row) => (
                <div className="Button-Tools">
                    <button
                        type="button"
                        className="btn btn-primary mr-2 "
                        onClick={() => {
                            setShow(true);
                            setModal({
                                headerComponent: "Editar Custo Oficial",
                                IconHeader: faEdit,
                                Component: () => (
                                    <CreateUpdateCustoOficial
                                        row={row}
                                        setShow={setShow}
                                        ListagemDeCustos={ListagemDeCustos}
                                        setDsPraca={setDsPraca}
                                        setFuncionario={setFuncionario}
                                        funcionario={funcionario}
                                        praca={dsPraca}
                                    />
                                ),
                                size: "lg",
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                    </button>

                    <button
                        type="button"
                        className="btn btn-danger mr-2"
                        disabled={RemocaoDeCustosLoading}
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja apagar este custo?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    RemocaoDeCustos(row.ID).then((response) => {
                                        ListagemDeCustos();
                                    });
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="lg" /> Excluir
                    </button>
                </div>
            ),
        },
    ];

    function handleFilterFormSubmit(formData: ICustosPayload) {
        const filterFormData = {
            ...formData,
            NR_MES: Number(mes),
            NR_ANO: Number(ano),
            DS_FUNCIONARIO: funcionario ? funcionario : "",
            DS_PRACA: dsPraca ? dsPraca : "",
            VL_FINAL: String(formData.VL_FINAL)
                ? String(formData.VL_FINAL)
                : String(filter?.VL_FINAL)
                ? String(filter?.VL_FINAL)
                : "0",
        };
        PageFilter.page = 1;
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_CUSTOS_OFICIAL",
            JSON.stringify(filterFormData)
        );
    }

    useEffect(() => {
        setAno(String(filter?.NR_ANO || ""));
        setMes(String(filter?.NR_MES || ""));
    }, [filter?.NR_ANO, filter?.NR_MES]);

    return (
        <>
            <div className="d-flex justify-content-end my-2">
                <button
                    className="btn btn-success"
                    onClick={() => {
                        setShow(true);
                        setModal({
                            headerComponent: "Cadastrar Custo Oficial",
                            IconHeader: faPlus,
                            Component: () => (
                                <CreateUpdateCustoOficial
                                    setShow={setShow}
                                    ListagemDeCustos={ListagemDeCustos}
                                    setDsPraca={setDsPraca}
                                    setFuncionario={setFuncionario}
                                    funcionario={funcionario}
                                    praca={dsPraca}
                                />
                            ),
                            size: "lg",
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </button>
            </div>
            <div className="card card-body">
                <Table
                    columns={columns}
                    data={lstCusto?.CUSTO ?? []}
                    keyField="ID"
                    onTableChange={(type, newState) => {
                        setPage(newState.page);
                    }}
                    remote={{ pagination: true }}
                    bordered={false}
                    loading={lstCustoLoading}
                    striped
                    noSearch
                    noDataIndication={() => (
                        <div className="text-center">
                            Nenhum dado encontrado
                        </div>
                    )}
                    totalPages={totalPages}
                />
            </div>
            <StickyToolbar
                Filters={
                    <FiltroCustoOficial
                        filter={filter}
                        filtroInicial={filtroInicial}
                        handleFilterFormSubmit={handleFilterFormSubmit}
                        setPage={setPage}
                        setFilter={setFilter}
                        setAno={setAno}
                        setMes={setMes}
                        ano={ano}
                        mes={mes}
                        setFuncionario={setFuncionario}
                        setDsPraca={setDsPraca}
                    />
                }
                active={!!FILTRO_CUSTOS_OFICIAL}
            />
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
